var fill = 'var(--_1q2ok2r1)';

export { fill };
//# sourceMappingURL=thumb.css.js.map
